export const shipmentContent = [
  "None",
  "Cartons",
  "Crates",
  "Pallets",
  "Drums",
  "Other",
];
